import React from "react";
import { Wordmark } from "./Brand";

const COLS = [
  {
    label: "Solutions",
    links: [
      { label: "AI Websites", href: "#services" },
      { label: "AI Automation", href: "#services" },
      { label: "AI Chatbots", href: "#services" },
      { label: "AI Analytics", href: "#services" },
      { label: "AI Compliance", href: "#services" },
      { label: "AI Agents", href: "#services" },
    ],
  },
  {
    label: "Company",
    links: [
      { label: "Validation", href: "#validation" },
      { label: "Why Us", href: "#why-us" },
      { label: "Contact", href: "#contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink-50 text-white pt-20 pb-10 overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 500px at 0% 0%, rgba(96,165,250,0.18) 0%, rgba(96,165,250,0) 60%)",
        }}
      />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-white">
              <Wordmark />
            </div>
            <p className="mt-5 max-w-sm text-white/65 leading-relaxed text-[15px]">
              AI Solutions for Modern Businesses. Implementation, not
              predictions — from local SMEs to regulated financial services.
            </p>
            <a
              href="mailto:contact@cityaistudio.com"
              data-testid="footer-email"
              className="mt-5 inline-block text-white border-b border-white/20 hover:border-white transition-colors"
            >
              contact@cityaistudio.com
            </a>
          </div>

          {COLS.map((c) => (
            <div key={c.label} className="lg:col-span-3">
              <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/55">
                {c.label}
              </div>
              <ul className="mt-5 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-white/80 hover:text-white transition-colors text-[15px]"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
          <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-white/45">
            © {new Date().getFullYear()} City AI Studio · Zurich, Switzerland
          </div>
          <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-white/45">
            Built for enterprise · Swiss precision
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
